export default "__VITE_PUBLIC_ASSET__5a0e58b7__"